const HISTORY_TOKEN_KEY = "minRenewalToken";

export function readRenewalEntry(win = globalThis.window) {
  if (win?.location?.pathname !== "/pay") return { token: "", outcome: "" };
  const params = new URLSearchParams(win.location.search || "");
  return {
    token: String(params.get("t") || win.history?.state?.[HISTORY_TOKEN_KEY] || "").trim(),
    outcome: ["return", "cancelled"].includes(params.get("outcome")) ? params.get("outcome") : "",
  };
}

export function scrubRenewalTokenFromUrl(win = globalThis.window) {
  if (win?.location?.pathname !== "/pay" || !win.history?.replaceState) return;
  const params = new URLSearchParams(win.location.search || "");
  const token = String(params.get("t") || "").trim();
  if (!token) return;
  params.delete("t");
  const query = params.toString();
  win.history.replaceState(
    { ...win.history.state, [HISTORY_TOKEN_KEY]: token },
    "",
    `/pay${query ? `?${query}` : ""}`,
  );
}

export function submitRenewalCheckout(payload, submit) {
  if (payload?.state !== "checkout") return false;
  const destination = new URL(payload.redirectUrl);
  if (
    destination.protocol !== "https:"
    || !["www.payfast.co.za", "sandbox.payfast.co.za"].includes(destination.hostname)
    || destination.pathname !== "/eng/process"
    || destination.username || destination.password || destination.port
    || !payload.paymentData || typeof payload.paymentData !== "object"
  ) throw new Error("Invalid checkout destination");
  submit({ redirectUrl: destination.href, paymentData: payload.paymentData });
  return true;
}

export function renewalNeedsPolling(state, attempts, reason = "") {
  return state === "pending" && reason !== "existing_checkout_needs_review" && attempts < 40;
}
